import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { GetIsFreeViewService } from '@/services/common/get-is-free-view.interface';
import { getIsFreeView } from 'library-@/utils/patent-view-free-judgment-util';

export const baseModule = new ContainerModule((bind) => {
    bind(GetIsFreeViewService).toConstantValue({
        getIsFreeView: getIsFreeView,
    });
});
